/**
 * nullかundefinedではないかチェックする
 * @param x value
 */
export const notUndefinedOrNull = <T>(x: T | undefined | null): x is T => {
  return x !== undefined && x !== null;
};
